export default "__VITE_ASSET__CWatG5Ro__"